/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { CartDto } from './CartDto';
import {
    CartDtoFromJSON,
    CartDtoFromJSONTyped,
    CartDtoToJSON,
} from './CartDto';
import type { DeliveryPointDto } from './DeliveryPointDto';
import {
    DeliveryPointDtoFromJSON,
    DeliveryPointDtoFromJSONTyped,
    DeliveryPointDtoToJSON,
} from './DeliveryPointDto';

/**
 * 
 * @export
 * @interface AddOrderDto
 */
export interface AddOrderDto {
    /**
     * 
     * @type {DeliveryPointDto}
     * @memberof AddOrderDto
     */
    deliveryPoint: DeliveryPointDto;
    /**
     * 
     * @type {string}
     * @memberof AddOrderDto
     */
    comment?: string;
    /**
     * 
     * @type {number}
     * @memberof AddOrderDto
     */
    deliveryMethodId?: number;
    /**
     * 
     * @type {string}
     * @memberof AddOrderDto
     */
    bookingOrderOrigin: string;
    /**
     * 
     * @type {string}
     * @memberof AddOrderDto
     */
    giftCardPhoneNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof AddOrderDto
     */
    vatType: AddOrderDtoVatTypeEnum;
    /**
     * 
     * @type {CartDto}
     * @memberof AddOrderDto
     */
    cart: CartDto;
}


/**
 * @export
 */
export const AddOrderDtoVatTypeEnum = {
    TAKEAWAY: 'TAKEAWAY',
    EAT_IN: 'EAT_IN'
} as const;
export type AddOrderDtoVatTypeEnum = typeof AddOrderDtoVatTypeEnum[keyof typeof AddOrderDtoVatTypeEnum];


/**
 * Check if a given object implements the AddOrderDto interface.
 */
export function instanceOfAddOrderDto(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "deliveryPoint" in value;
    isInstance = isInstance && "bookingOrderOrigin" in value;
    isInstance = isInstance && "vatType" in value;
    isInstance = isInstance && "cart" in value;

    return isInstance;
}

export function AddOrderDtoFromJSON(json: any): AddOrderDto {
    return AddOrderDtoFromJSONTyped(json, false);
}

export function AddOrderDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): AddOrderDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'deliveryPoint': DeliveryPointDtoFromJSON(json['deliveryPoint']),
        'comment': !exists(json, 'comment') ? undefined : json['comment'],
        'deliveryMethodId': !exists(json, 'deliveryMethodId') ? undefined : json['deliveryMethodId'],
        'bookingOrderOrigin': json['bookingOrderOrigin'],
        'giftCardPhoneNumber': !exists(json, 'giftCardPhoneNumber') ? undefined : json['giftCardPhoneNumber'],
        'vatType': json['vatType'],
        'cart': CartDtoFromJSON(json['cart']),
    };
}

export function AddOrderDtoToJSON(value?: AddOrderDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'deliveryPoint': DeliveryPointDtoToJSON(value.deliveryPoint),
        'comment': value.comment,
        'deliveryMethodId': value.deliveryMethodId,
        'bookingOrderOrigin': value.bookingOrderOrigin,
        'giftCardPhoneNumber': value.giftCardPhoneNumber,
        'vatType': value.vatType,
        'cart': CartDtoToJSON(value.cart),
    };
}

